import { Injectable } from '@angular/core';
import { clone } from 'lodash-es';
import { BaseVariableService } from '@wms/variables';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterCriteriaService {
  filterFields: any;
  DEFAULT_CONDITION = "AND";
  DEFAULT_MATCHMODE = "anywhereignorecase";
  DEFAULT_FIELD_TYPE = "string";
  DEFAULT_REQUIRED_FLAG = false;

  FILTER_CRITERIA_DIALOG = "filterCriteria";

  CRITERIA = {
    target: '',
    type: this.DEFAULT_FIELD_TYPE,
    matchMode: this.DEFAULT_MATCHMODE,
    value: '',
    required: this.DEFAULT_REQUIRED_FLAG
  };
  CRITERIA_GROUP = {
    "condition": this.DEFAULT_CONDITION,
    "rules": [clone(this.CRITERIA)]
  };

  data: any = {
    'queryPreview': '',
    'fieldsTypeMap': {}
  };
  filterExpressions: any;
  queryPreviewSubject: any = new Subject();
  previousResponse: any = {};

  constructor(private variableService: BaseVariableService) { }

  markVariableUpdated() {
    if (this.variableService.selectedVariable) {
      this.variableService.markUpdated();
      this.variableService.selectedVariable.variableObject['filterExpressions'] = this.filterExpressions;
    }
    this.queryPreviewSubject.next();
  }

  addRule(rules: any) {
    rules.rules.push(clone(this.CRITERIA));
  }

  queryPreviewObs() {
    return this.queryPreviewSubject.asObservable();
  }
}
